export interface FaqItem {
  q: string;
  a: string;
}

export const newsFaq: FaqItem[] = [
  {
    q: "吃瓜新闻的快讯多久更新一次？",
    a: "我们的快讯实行全天滚动更新，工作日与周末均有编辑团队轮值。重大事件与突发消息会第一时间以直播条形式推送到首页顶部，并可前往「直播」频道查看完整时间线。",
  },
  {
    q: "早报和晚报分别是什么时间推送？",
    a: "早报在每日早上六点半左右整理上线，帮助您在通勤路上快速掌握昨夜今晨的关键要闻；晚报在晚间八点左右更新，汇总当日全天重点信息。两者都能在首页与栏目页固定入口查看。",
  },
  {
    q: "如何找到我关心的分类内容？",
    a: "首页按「娱乐、社会、科技、财经、体育」等栏目分区展示，顶部导航可直接进入任一分类页浏览完整列表。您也可以使用全站搜索，输入关键词快速定位相关报道。",
  },
  {
    q: "直播频道里的消息可以追溯查看吗？",
    a: "可以。直播频道提供完整的时间线，支持按栏目筛选，并配有暂停滚动功能，方便您逐条阅读。每条快讯均保留发布时间与来源栏目，不会因滚动而丢失。",
  },
  {
    q: "报道的内容是否可靠，如何保证真实？",
    a: "吃瓜新闻坚持信源可溯的原则，所有快讯均需标注信息来源并经过编辑核实后发布。对存疑或仍在演进的消息，我们会明确标注进展状态，避免把传闻当作事实传播。",
  },
];